import { createFileRoute } from "@tanstack/react-router";
import { TranslationAdminPage } from "@/components/translation/admin/TranslationAdminPage";

export const Route = createFileRoute("/_app/admin/translation")({ component: TranslationAdminPage });
